import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex justify-end items-center gap-4"
}
const _hoisted_3 = { class: "overflow-x-auto lg:overflow-x-hidden mt-2" }
const _hoisted_4 = {
  key: 0,
  class: "min-w-[750px] lg:min-w-[900px] max-w-full overflow-x-auto lg:overflow-x-hidden w-full border-separate border border-neutral-200 rounded-lg bg-white"
}
const _hoisted_5 = { class: "text-left text-base-200" }
const _hoisted_6 = {
  key: 0,
  class: "w-[35px] px-3 py-2.5 font-medium"
}
const _hoisted_7 = {
  key: 1,
  class: "w-[20%] 2xl:min-w-[230px] px-3 py-2.5 font-medium"
}
const _hoisted_8 = { class: "flex items-center gap-2.5" }
const _hoisted_9 = {
  key: 2,
  class: "2xl:min-w-[110px] px-3 py-2.5 font-medium"
}
const _hoisted_10 = {
  key: 0,
  class: "h-[200px]"
}
const _hoisted_11 = {
  key: 0,
  class: "w-[35px] border-t border-t-neutral-200 px-3 py-2.5"
}
const _hoisted_12 = {
  key: 1,
  class: "w-[20%] 2xl:min-w-[230px] border-t border-t-neutral-200 px-3 py-2.5"
}
const _hoisted_13 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_14 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "2xl:min-w-[110px] border-t border-t-neutral-200 py-2.5 text-right"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "text-center text-lg font-bold mb-8" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-[20px] leading-lg font-bold" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-[20px] leading-lg font-bold" }

import { AppConfigType, DropdownOptionType, PostType, PostStatusType } from '~src/admin/types';
import IconPlus from '../icons/IconPlus.vue';
import Badge from '../base/Badge.vue';
import IconQuestionCircle from '../icons/IconQuestionCircle.vue';
import Tooltip from '../base/Tooltip.vue';
import Checkboxes from '../form/Checkboxes.vue';
import Dropdown from '../navigation/Dropdown.vue';
import IconGear from '../icons/IconGear.vue';
import IconRefresh from '../icons/IconRefresh.vue';
import IconEye from '../icons/IconEye.vue';
import IconTrash from '../icons/IconTrash.vue';
import IconWarning from '../icons/IconWarning.vue';
import Message from '../base/Message.vue';
import Popup from '../layout/Popup.vue';
import { inject, ref, watch } from 'vue';
import { useNotificationStore } from '~src/admin/stores/useNotificationStore';
import Axios from '~src/shared/axios';
import Button from '../base/Button.vue';
import PopupTextarea from '../layout/PopupTextarea.vue';
import { useGettext } from 'vue3-gettext';
import PostKeywords from './PostKeywords.vue';
import { useTokensStore } from '~src/admin/stores/useTokensStore';

// Translations

export default /*@__PURE__*/_defineComponent({
  __name: 'PostsTable',
  props: {
    posts: {},
    type: {},
    loading: { type: Boolean }
  },
  emits: ["updatePosts", "updateKeywords", "reloadPosts"],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();

// Get plugin config
const config: AppConfigType = inject('pluginConfig');

// Show notification
const { addNotification } = useNotificationStore();

// Control tokens
const { isTokenLimitReached, updateTokens } = useTokensStore();

// Props


// Emits
const emit = __emit;

// Loading
const requestLoading = ref(false);

// Dropdown options
const isAccountFree = inject<boolean>('isAccountFree');
const isAccountExpired = inject<boolean>('isAccountExpired');

const optionsDisabled = isAccountFree || isAccountExpired;
const dropdownOptions: DropdownOptionType[] = [
    {
        label: $gettext('Regenerate'),
        selected: false,
        icon: IconRefresh,
        disabled: optionsDisabled ? false : isTokenLimitReached.value,
    },
    {
        label: $gettext('Preview'),
        selected: false,
        icon: IconEye,
    },
    {
        label: isAccountFree ? $gettext('Delete (paid plan only)') : $gettext('Delete'),
        selected: false,
        icon: IconTrash,
        disabled: optionsDisabled,
    },
];

// Parse dropdown options for a specific post
const parseDropdownOptions = (dropdownOptions: DropdownOptionType[], status: PostStatusType) => {
    // If post has no content remove regenerate option
    if (status === 'schedule_generate' || status === 'published') {
        return dropdownOptions.map((option) => {
            if (option.label === $gettext('Regenerate')) {
                return { ...option, disabled: true };
            }
            return option;
        });
    }
    return dropdownOptions;
};

// Map for status
const statusMap = {
    published: {
        label: $gettext('Published'),
        type: 'success',
    },
    schedule_generate: {
        label: $gettext('Scheduled to be generated'),
        type: 'warning',
    },
    schedule_publish: {
        label: $gettext('Scheduled for publication'),
        type: 'info',
    },
};

// Popup control
const deletePopup = ref<InstanceType<typeof Popup>>();
const regeneratePopup = ref<InstanceType<typeof Popup>>();
const keywordPopup = ref<InstanceType<typeof PopupTextarea>>();

// Store keywords
const keywords = ref('');
const currentPostID = ref('');

// Save keywords
const saveKeywords = () => {
    // Keywords array
    let keywordsArr = keywords.value.split(/,|\r?\n/);

    // Make sure empty array is empty
    if (keywords.value.length === 0) {
        keywordsArr = [];
    }

    // Prepare new posts
    const newPosts = __props.posts.map((p) => {
        if (p.id === currentPostID.value) {
            // Save to a article
            const newPost = p;
            newPost.keywords = keywordsArr;
            return newPost;
        }
        return p;
    });

    // Get weekday index
    const currentPost = __props.posts.find((p) => p.id === currentPostID.value);
    const date = new Date(currentPost.publish_date);

    // Update the posts in the parent
    emit('updatePosts', newPosts);

    // Update the keywords in the schedule
    emit('updateKeywords', keywordsArr, date.getDay(), currentPost.timeIndex ?? null);

    // Close the popup
    keywordPopup.value.closePopup();
};

// Open keywords popup and set current id
const openKeywordsPopup = (id: string) => {
    currentPostID.value = id;
    const currentPost = __props.posts.find((p) => p.id === id);

    // If current post has keywords, add them
    if (currentPost?.keywords) {
        keywords.value = currentPost.keywords.join(', ');
    }

    keywordPopup.value.openPopup();
};

// Single article actions
const selectedPost = ref<string | null>(null);

// Handle option click in dropdown
const handleOption = (option: string, index: number) => {
    // Set the article to perform action
    if (option.toLowerCase() === 'delete' || option.toLowerCase() === 'regenerate') {
        selectedPost.value = __props.posts[index].id;
    }

    if (option.toLowerCase() === 'delete') {
        // Show delete popup
        deletePopup.value.openPopup();
    } else if (option.toLowerCase() === 'regenerate') {
        // Show regenerate popup
        regeneratePopup.value.openPopup();
    } else if (option.toLowerCase() === 'preview') {
        // Go to post edit page
        window.open(__props.posts[index].post_link, '_blank');
    }
};

// Bulk actions checkboxes
const allPosts = ref<string[]>([]);
const selectedPosts = ref<string[]>([]);

// Select all posts
watch(allPosts, (newAllPosts) => {
    if (newAllPosts.includes('all_posts')) {
        // Select all
        selectedPosts.value = __props.posts.map((p) => p.id.toString());
    } else {
        // Deselect all
        selectedPosts.value = [];
    }
});

// Bulk remove articles
const bulkRemoveArticles = () => {
    selectedPost.value = null;
    deletePopup.value.openPopup();
};

// Remove article
const removeArticle = async () => {
    try {
        // Start the call
        const body = prepareCall();

        // Call the WordPress Rest API to remove posts
        const response = await Axios.delete(config.rest.endpoints.posts, {
            data: body,
        });

        // Check if the response is successful
        if (response.status !== 200 || !response.data.success) {
            throw new Error(`REST API error: ${response.status} - ${response.statusText}`);
        }

        // Show all notificaitons
        showResponseMessages(
            response.data.post_success,
            response.data.post_errors,
            $gettext('Successfully deleted post'),
            $gettext("Couldn't delete post")
        );
    } catch (error) {
        console.error('Error during API call:', error);

        // Show error
        addNotification({
            message: $gettext('There was an error with deleting the posts!'),
            type: 'danger',
        });
    } finally {
        // Close popup
        deletePopup.value.closePopup();
        responseCleanup();
    }
};

// Bulk regenerate articles
const bulkRegenerateArticles = () => {
    selectedPost.value = null;
    regeneratePopup.value.openPopup();
};

// Regenerate article
const regenerateArticle = async () => {
    try {
        // Start the call
        const body = prepareCall();

        // Call the WordPress Rest API to regenerate posts
        const regenerateResponse = await Axios.post(`${config.rest.endpoints.posts}/regenerate`, body);

        // Check if the response is successful
        if (regenerateResponse.status !== 200 || !regenerateResponse.data.success) {
            throw new Error(`REST API error: ${regenerateResponse.status} - ${regenerateResponse.statusText}`);
        }

        // Show all notificaitons
        showResponseMessages(
            regenerateResponse.data.post_success,
            regenerateResponse.data.post_errors,
            $gettext('Successfully regenerated post'),
            $gettext("Couldn't regenerate post")
        );

        // Update tokens
        updateTokens();
    } catch (error) {
        console.error('Error during API call:', error);

        // Show error
        addNotification({
            message: $gettext('There was an error with regenerating the posts!'),
            type: 'danger',
        });
    } finally {
        // Close popup
        regeneratePopup.value.closePopup();
        responseCleanup();
    }
};

// Show API response messages
const showResponseMessages = (postSuccess: number[], postError: number[], successMsg: string, errorMsg: string) => {
    // Show success notificaitons
    postSuccess.forEach((postID: number) => {
        addNotification({
            message: `${successMsg} ${postID}!`,
            type: 'success',
        });
    });

    // Show error notificaitons
    postError.forEach((postID: number) => {
        addNotification({
            message: `${errorMsg} ${postID}!`,
            type: 'danger',
        });
    });
};

// Prepare API call
const prepareCall = () => {
    // Set loading
    requestLoading.value = true;

    // Prepare the body
    // If single article is selected use it instead perform action on all selected
    const body = {
        ids: selectedPost.value ? [selectedPost.value] : selectedPosts.value,
    };

    return body;
};

// After API call cleanup
const responseCleanup = () => {
    // Set loading
    requestLoading.value = false;

    // Reset selected posts
    if (selectedPost.value === null) {
        selectedPosts.value = [];
    } else {
        selectedPost.value = null;
    }

    // Reload posts
    emit('reloadPosts');
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (selectedPosts.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "flex gap-1.5 items-center cursor-pointer transition-colors hover:text-base-200",
              onClick: bulkRegenerateArticles,
              onKeypress: _withKeys(bulkRegenerateArticles, ["enter","space"]),
              tabindex: "0"
            }, [
              _createVNode(IconRefresh),
              _createElementVNode("p", null, _toDisplayString(_unref($gettext)('Regenerate')) + " (" + _toDisplayString(selectedPosts.value.length) + " articles)", 1)
            ], 32),
            _createElementVNode("div", {
              class: "flex gap-1.5 items-center text-danger-500 cursor-pointer transition-colors hover:text-danger-300",
              onClick: bulkRemoveArticles,
              onKeypress: _withKeys(bulkRegenerateArticles, ["enter","space"]),
              tabindex: "0"
            }, [
              _createVNode(IconTrash),
              _createElementVNode("p", null, _toDisplayString(_unref($gettext)('Delete')) + " (" + _toDisplayString(selectedPosts.value.length) + " articles)", 1)
            ], 32)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.posts.length)
          ? _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_4, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_ctx.type === 'full')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_6, [
                        _createVNode(Checkboxes, {
                          options: [{ label: '', value: 'all_posts' }],
                          name: "all_posts",
                          modelValue: allPosts.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((allPosts).value = $event)),
                          "global-disabled": _unref(isAccountExpired)
                        }, null, 8, ["modelValue", "global-disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                                '2xl:w-full px-3 py-2.5 font-medium',
                                _unref(isAccountFree) && 'w-[40%]',
                                !_unref(isAccountFree) && 'w-[25%]',
                            ])
                  }, _toDisplayString(_unref($gettext)('Article')), 3),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                                '2xl:min-w-[190px] px-3 py-2.5 font-medium',
                                _unref(isAccountFree) && 'w-[25%]',
                                !_unref(isAccountFree) && 'w-[15%]',
                            ])
                  }, _toDisplayString(_unref($gettext)('Date of publication')), 3),
                  (_ctx.type === 'full')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_unref($gettext)('Status')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                                'px-3 py-2.5 font-medium',
                                _unref(isAccountFree) && 'w-[35%] 2xl:min-w-[220px]',
                                !_unref(isAccountFree) && 'w-[25%] 2xl:min-w-[350px]',
                            ])
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_unref($gettext)('Keywords')), 1),
                      _createVNode(Tooltip, {
                        content: 
                                        _unref($gettext)(
                                            'Keywords match user queries, improve visibility, target specific audiences, guide content strategy, and enhance user experience, helping search engines index and rank your content effectively.'
                                        )
                                    ,
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(IconQuestionCircle)
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ])
                  ], 2),
                  (_ctx.type === 'full')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_9))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: post.id
                  }, [
                    (_ctx.type === 'full')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                          _createVNode(Checkboxes, {
                            options: [{ label: '', value: post.id.toString() }],
                            name: "posts",
                            modelValue: selectedPosts.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPosts).value = $event)),
                            "global-disabled": _unref(isAccountExpired)
                          }, null, 8, ["options", "modelValue", "global-disabled"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", {
                      class: _normalizeClass([
                                '2xl:min-w-[unset] border-t border-t-neutral-200 px-3 py-2.5',
                                _unref(isAccountFree) && 'w-[40%]',
                                !_unref(isAccountFree) && 'w-[25%]',
                            ])
                    }, _toDisplayString(post.title), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass([
                                '2xl:min-w-[190px] border-t border-t-neutral-200 px-3 py-2.5',
                                _unref(isAccountFree) && 'w-[25%]',
                                !_unref(isAccountFree) && 'w-[15%]',
                            ])
                    }, _toDisplayString(post.publish_date), 3),
                    (_ctx.type === 'full')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          _createVNode(Message, {
                            message: statusMap[post.status].label,
                            type: statusMap[post.status].type,
                            "show-icon": false
                          }, null, 8, ["message", "type"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", {
                      class: _normalizeClass([
                                'border-t border-t-neutral-200 px-3 py-2.5',
                                _unref(isAccountFree) && 'w-[35%] 2xl:min-w-[220px]',
                                !_unref(isAccountFree) && 'w-[25%] 2xl:min-w-[350px]',
                            ])
                    }, [
                      (_ctx.type === 'compact')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (post.keywords.length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(Button, {
                                    class: "pl-0",
                                    text: _unref($gettext)('Add keywords'),
                                    type: "secondary",
                                    size: "small",
                                    "has-background": false,
                                    "icon-position": 'left',
                                    disabled: _unref(isAccountFree),
                                    onClick: _withModifiers(($event: any) => (_unref(isAccountFree) ? null : openKeywordsPopup(post.id)), ["prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(IconPlus)
                                    ]),
                                    _: 2
                                  }, 1032, ["text", "disabled", "onClick"]),
                                  (_unref(isAccountFree))
                                    ? (_openBlock(), _createBlock(Badge, {
                                        key: 0,
                                        type: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref($gettext)('PRO feature')), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "flex gap-1.5 flex-wrap",
                                  onClick: ($event: any) => (_unref(isAccountFree) ? null : openKeywordsPopup(post.id))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.keywords, (keyword, i) => {
                                    return (_openBlock(), _createBlock(Message, {
                                      key: i,
                                      message: keyword,
                                      type: "neutral",
                                      "show-icon": false
                                    }, null, 8, ["message"]))
                                  }), 128))
                                ], 8, _hoisted_15))
                          ]))
                        : (_ctx.type === 'full' && !_unref(isAccountFree))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(PostKeywords, {
                                keywords: post.keywords
                              }, null, 8, ["keywords"])
                            ]))
                          : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.type === 'full')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                          _createVNode(Dropdown, {
                            options: parseDropdownOptions(dropdownOptions, post.status),
                            placement: "bottom-end",
                            onSelectOption: (option) => handleOption(option, i)
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(IconGear, { class: "mt-1 mx-3 group-aria-expanded:text-primary-500" })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["options", "onSelectOption"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          : (!_ctx.posts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref($gettext)('No posts to display!')), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Popup, {
      ref_key: "regeneratePopup",
      ref: regeneratePopup,
      "cancel-button-text": _unref($gettext)('Cancel'),
      "confirm-button-text": _unref($gettext)('Regenerate'),
      size: "small",
      onPopupConfirm: regenerateArticle,
      loading: requestLoading.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(IconWarning, { class: "mb-4 mx-auto" }),
          _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref($gettext)('Are you sure?')), 1),
          _createElementVNode("p", null, _toDisplayString(_unref($gettext)('Regenerating the article will use one of your weekly articles credits.')), 1)
        ])
      ]),
      _: 1
    }, 8, ["cancel-button-text", "confirm-button-text", "loading"]),
    _createVNode(Popup, {
      ref_key: "deletePopup",
      ref: deletePopup,
      "cancel-button-text": _unref($gettext)('Cancel'),
      "confirm-button-text": _unref($gettext)('Delete'),
      "confirm-button-type": "danger",
      size: "small",
      onPopupConfirm: removeArticle,
      loading: requestLoading.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(IconWarning, { class: "mb-4 mx-auto" }),
          _createElementVNode("h2", _hoisted_23, _toDisplayString(_unref($gettext)('Are you sure?')), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref($gettext)('Deleting the article will remove it from articles list and from your website.')) + " ", 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref($gettext)("You won't be able to restore it.")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["cancel-button-text", "confirm-button-text", "loading"]),
    _createVNode(PopupTextarea, {
      ref_key: "keywordPopup",
      ref: keywordPopup,
      "cancel-button-text": _unref($gettext)('Cancel'),
      "confirm-button-text": _unref($gettext)('Add keywords'),
      heading: _unref($gettext)('Add keywords'),
      placeholder: _unref($gettext)('Use comma or enter for separating keywords'),
      onPopupConfirm: saveKeywords,
      modelValue: keywords.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((keywords).value = $event))
    }, null, 8, ["cancel-button-text", "confirm-button-text", "heading", "placeholder", "modelValue"])
  ], 64))
}
}

})